export function nFormatter(num = 0, digits = 1) {
	const lookup = [
		{ value: 1, symbol: "" },
		{ value: 1e3, symbol: "k" },
		{ value: 1e6, symbol: "M" },
		{ value: 1e9, symbol: "G" },
		{ value: 1e12, symbol: "T" },
		{ value: 1e15, symbol: "P" },
		{ value: 1e18, symbol: "E" }
	];

	const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
	const item = lookup
		.slice()
		.reverse()
		.find(function (item) {
			return num >= item.value;
		});

	return item
		? (num / item.value).toFixed(digits).replace(rx, "$1") + item.symbol
		: "0";
}

export function formatCompactNumber(value?: number | string, digits = 1) {
	if (value === undefined || value === "") {
		return "";
	}

	const numericValue =
		typeof value === "string" ? Number(value.replace(/,/g, "")) : value;

	if (!Number.isFinite(numericValue)) {
		return String(value);
	}

	return new Intl.NumberFormat("en-US", {
		notation: "compact",
		compactDisplay: "short",
		maximumFractionDigits: digits,
		roundingMode: "floor"
	}).format(numericValue);
}
